import { render } from "./welcome.vue?vue&type=template&id=5cb421d0&scoped=true"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"

import "./welcome.vue?vue&type=style&index=0&id=5cb421d0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb421d0"]])

export default __exports__